import React, { Component, PropTypes } from 'react';
import { List, makeSelectable } from 'material-ui';

export const defaultStyle = {
  workspaceLeftnavContent: {
    overflowY: 'scroll',
    overflowX: 'none',
    '& .flex-tc-sb': {
      padding: '0 16px',
    },
    '&::-webkit-scrollbar': {
      width: '0 !important',
    },
    '-ms-overflow-style': 'none',
  },
  slimProgress: {
    height: '1px !important',
    position: 'absolute !important',
  },
  workspaceMenuItem: {
    fontSize: '0.9em !important',
    lineHeight: '20px !important',
    minHeight: '20px !important',
  },
  leftNavClass: {
    marginTop: '0 !important',
    backgroundColor: 'rgb(240, 240, 240)',
    color: '#757575 !important', // #00bcd4 < -- selected
  },
  workspaceConnectionList: {
    padding: '0 !important',
    '& div > span': {
      height: '58px',
    },
  },
};

function wrapState(ComposedComponent) {
  class SelectableListClass extends Component {
    static propTypes = {
      children: PropTypes.node.isRequired,
      defaultValue: PropTypes.number.isRequired,
    };
    componentWillMount() {
      this.setState({
        selectedIndex: this.props.defaultValue,
      });
    }

    componentWillReceiveProps(newProps) {
      if (this.props.defaultValue !== newProps.defaultValue) {
        this.setState({
          selectedIndex: newProps.defaultValue,
        });
      }
    }

    handleRequestChange = (event, index) => {
      this.setState({
        selectedIndex: index,
      }, () => {
        if (this.props.selectAction) {
          this.props.selectAction(this.state.selectedIndex);
        }
      });
    };

    render() {
      return (
        <div className={`${this.props.className} ${this.props.classes.leftNavClass}`}>
          <div className={`workspace-leftnav-content ${this.props.classes.workspaceLeftnavContent}`}>
            <ComposedComponent
              value={this.state.selectedIndex}
              onChange={this.handleRequestChange}
              className={this.props.classes.workspaceConnectionList}
            >
              {this.props.children}
            </ComposedComponent>
          </div>
        </div>
      );
    }
  }
  SelectableListClass.propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
    classes: PropTypes.object,
    selectAction: PropTypes.func,
  };

  return SelectableListClass;
}


export default wrapState(makeSelectable(List));



// WEBPACK FOOTER //
// ./src/app/components/workspace/leftNav.jsx